import { useLocation } from 'react-router-dom';
import { POST_LOGIN_VIDEO_PATH } from '../PostLoginVideo';
import { isPreLoginAuthPath } from '../utils/isPreLoginAuthPath';

function isPostLoginIntroPath(pathname) {
  if (pathname == null) {
    throw new Error('isPostLoginIntroPath: pathname is required');
  }
  const path = String(pathname).split('?')[0];
  return path === POST_LOGIN_VIDEO_PATH || path.startsWith(`${POST_LOGIN_VIDEO_PATH}/`);
}

/**
 * Season end warnings/dialog only while logged in, past auth screens, and past
 * the post-login intro video. Earliest after login is Welcome.
 * @param {boolean} isLoggedIn
 * @returns {boolean}
 */
export function useSeasonUiEnabled(isLoggedIn) {
  const location = useLocation();
  if (!isLoggedIn) {
    return false;
  }
  if (isPreLoginAuthPath(location.pathname)) {
    return false;
  }
  return !isPostLoginIntroPath(location.pathname);
}

export default useSeasonUiEnabled;
